import { render, staticRenderFns } from "./keywords-to-insert-batch-details.component.html?vue&type=template&id=b7e76b00&scoped=true&external"
import script from "./keywords-to-insert-batch-details.component.vue?vue&type=script&lang=ts"
export * from "./keywords-to-insert-batch-details.component.vue?vue&type=script&lang=ts"
import style0 from "./keywords-to-insert-batch-details.component.css?vue&type=style&index=0&id=b7e76b00&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e76b00",
  null
  
)

export default component.exports